import {Timecode} from 'timecode';
import {curry} from 'ramda';

const DROP_FRAME_RATES = [29.97, 59.94];

export const isDropFrame = (frameRate: number) => DROP_FRAME_RATES.includes(frameRate);

const getFrameRate = (framerateNumerator: any, framerateDenominator: any) => {
    return Number((framerateNumerator / framerateDenominator).toFixed(2));
};

const getBreakpointValue = (array: any, frameRate: any) => {
    return array.map(getSMPTE(frameRate));
};

const getSMPTE = curry((framerate, frameNumber) => {
    const SMPTE = Timecode.init({
        drop_frame: isDropFrame(framerate),
        framerate,
    });
    SMPTE.add(frameNumber);
    
    return SMPTE.toString();
});

const getBreakpointsFrameNumbers = (item: any) => item.frameNumber;
const getBreakpointObjects = (breakpoint: any) => ({
    breakpoint,
});

export const parseBreakpointsData = (techData: any, breakpointFrames: any) => {
    if (!breakpointFrames)
        return [];
    
    const {
        framerateDenominator,
        framerateNumerator,
    } = techData;
    const frameRate = getFrameRate(framerateNumerator, framerateDenominator);
    const breakpointsFrameNumbers = breakpointFrames.map(getBreakpointsFrameNumbers);
    
    return getBreakpointValue(
        breakpointsFrameNumbers,
        frameRate,
    ).map(getBreakpointObjects);
};
